{
  "drag_handle": "Drag to reorder",
  "move_up": "Move up",
  "move_down": "Move down"
}
